<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Position" subTitle="Forms" />

    <CreatePosition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreatePosition from "@/components/Pages/Master/Position/CreatePosition.vue";

export default defineComponent({
  name: "CreatePositionPage",
  components: {
    PageTitle,
    CreatePosition,
  },
});
</script>
